import { useSelector } from 'react-redux';
import { getActiveError } from '../store/error/selectors';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { getIsAcq136SignupRequestLoading } from '../experiments/acq136/acq136Selectors';
import { getStepConfig } from '../views/getStepConfig';
import { Step } from '../views/Step';
import { WaveType } from '../wave/Wave';
import { useCurrentStep } from './useCurrentStep';
export const useIsWideStep = () => {
  const activeLoading = useSelector(getActiveLoading);
  const postAccountCreation = useSelector(getPostAccountCreationSteps);
  const {
    currentStep
  } = useCurrentStep();
  const activeError = useSelector(getActiveError);
  const step = activeError || currentStep;
  const stepConfig = getStepConfig(step);
  const isWideStep = stepConfig ? stepConfig.isWideStep : false;
  const waveType = stepConfig && stepConfig.waveType;
  const shouldShowWavePostAccountCreation = stepConfig && stepConfig.shouldShowWavePostAccountCreation;
  const isPostAccountCreationStep = postAccountCreation.includes(currentStep);
  const isAcq136SignupRequestLoading = useSelector(getIsAcq136SignupRequestLoading);

  if (activeLoading && !isAcq136SignupRequestLoading) {
    return {
      isWideStep: true
    };
  }

  if (isPostAccountCreationStep && currentStep !== Step.GoogleContactsSync) {
    return Object.assign({
      isWideStep
    }, shouldShowWavePostAccountCreation && {
      waveType: waveType || WaveType.PostAccountCreation
    });
  }

  return Object.assign({
    isWideStep
  }, isWideStep && {
    waveType
  });
};